import * as React from 'react';
import { Trans } from '@lingui/react/macro';
import Footer from 'components/Footer';
import Header from 'components/Header';

const SessionUnavailable: React.FC = () => (
  <div className="ext3d-brand-layout flex h-screen flex-col items-stretch" data-testid="session-unavailable">
    <Header />
    <div className="ex3d-brand-page-background flex size-full grow flex-col items-center justify-center p-10">
      <h3 className="text-center text-2xl font-bold">
        <Trans>Session Unavailable</Trans>
      </h3>
      <p className="mt-2 text-center text-sm">
        <Trans>The session was cancelled or rescheduled. Please contact your dealer for details.</Trans>
      </p>
    </div>
    <Footer withoutWltp />
  </div>
);

export default SessionUnavailable;
